import { BaseFilterOutput } from "../../../common-models/BaseFilterOutput";
import { OrderForListing } from "../../../models/OrderForListing";

export class FilterOrderForListingOutput extends BaseFilterOutput<OrderForListing> {
}